import { ArrowRight } from "@phosphor-icons/react";
import { TFunction } from "i18next";

export interface ActivityChangesProps {
  t: TFunction;
  changes: Array<{ field: string; old: unknown; new: unknown }>;
  meta?: Record<string, unknown> | null;
  renderChangePill: (
    t: TFunction,
    value: unknown,
    type: "old" | "new",
    field?: string
  ) => JSX.Element;
}

const ActivityChanges = ({ t, changes, meta, renderChangePill }: ActivityChangesProps) => {
  return (
    <div className="mt-2 flex flex-col gap-1">
      {changes.map((change, idx) => {
        const updatedChange = { ...change } as { field: string; old: unknown; new: unknown };

        const bidMethod = (meta?.["bid_method"] as string | undefined) || undefined;
        const currencySymbol = (meta?.["currency_symbol"] as string | undefined) || "₹";

        if (change.field === "bid") {
          updatedChange.new = bidMethod === "TARGET_ROAS" ? `${change.new} %` : `${currencySymbol} ${change.new}`;
          updatedChange.old = bidMethod === "TARGET_ROAS" ? `${change.old} %` : `${currencySymbol} ${change.old}`;
        }

        return (
          <div key={idx} className="flex items-center flex-wrap gap-2 text-xs">
            <span className="font-medium text-gray-600">
              {t(`userActivity.fields.${updatedChange.field}`, updatedChange.field)}
            </span>
            <span>:</span>
            {renderChangePill(t, updatedChange.old, "old", updatedChange.field)}
            <ArrowRight size={16} className="text-gray-500" weight="duotone" />
            {renderChangePill(t, updatedChange.new, "new", updatedChange.field)}
          </div>
        );
      })}
    </div>
  );
};

export default ActivityChanges;


